import type { SizingBehaviorPresets } from '@wix/editorx-core-api';

export const TranslationKeys = {
  mainGfppAction: 'Pagination_Gfpp_Main_Action',
  layoutPanelPageTypeArrows: 'Pagination_Bar_Layout_Page_Type_Arrows',
  layoutPanelPageTypeInput: 'Pagination_Bar_Layout_Page_Type_Input',
  layoutPanelPageTypeClick: 'Pagination_Bar_Layout_Page_Type_Click',
  layoutPanelAlignment: 'Pagination_Bar_Layout_Alignment',
  layoutPanelDirection: 'Pagination_Bar_Layout_Direction',
  layoutPanelAlignmentLeft: 'Pagination_Bar_Layout_Alignment_Left',
  layoutPanelAlignmentCenter: 'Pagination_Bar_Layout_Alignment_Center',
  layoutPanelAlignmentRight: 'Pagination_Bar_Layout_Alignment_Right',
  layoutPanelAlignmentSpread: 'Pagination_Bar_Layout_Alignment_Spread',
  layoutPanelTitle: 'Pagination_Bar_Layout_Panel_Title',
  layoutPanelShowCurrentPage: 'Pagination_Bar_Layout_Show_Current_Page',
  layoutPanelVeloWarning: 'TABLE_LAYOUT_PAGINATION_VELO_WARNING',
  showFirstLastButtons: 'Pagination_Bar_Settings_Show_FirstLast_Buttons_Toogle',
  showCurrentPage: 'Pagination_Bar_Layout_Show_Current_Page',
  showFirstLastPages: 'Pagination_Bar_Settings_Show_FirstLast_Pages_Toogle',
  showTotalPages: 'Pagination_Bar_Settings_Show_TotalPages_Toogle',
  navigationType: 'Pagination_Bar_Settings_Navigation_Buttons_Label',
  buttonTextNavigation: 'Pagination_Bar_Settings_Navigation_ButtonText_Label',
  previousTextPlaceholder:
    'Pagination_Bar_Pagination_Bar_Settings_PreviousButton_Placeholder',
  previousTextLabel: 'Pagination_Bar_Settings_PreviousButton_Label',
  nextTextPlaceholder: 'Pagination_Bar_Settings_NextButton_Placeholder',
  nextTextLabel: 'Pagination_Bar_Settings_NextButton_Label',
  firstButtonLabel: 'Pagination_Bar_Settings_FirstButton_Label',
  firstButtonPlaceholder: 'Pagination_Bar_Settings_FirstButton_Placeholder',
  lastButtonLabel: 'Pagination_Bar_Settings_LastButton_Label',
  lastButtonPlaceholder: 'Pagination_Bar_Settings_LastButton_Placeholder',
  layoutLabel: 'Pagination_Bar_Layouts_display_pagination_label',
  paginationModeLabel: 'Pagination_Bar_Settings_Specific_Page_Label',
  navigationButtonArrowsLabel:
    'Pagination_Bar_Settings_Navigation_Buttons_Arrows',
  navigationButtonArrowsText: 'Pagination_Bar_Settings_Navigation_Buttons_Text',
  ltrLabel: 'Pagination_Bar_Layouts_display_pagination_lefttoright_label',
  rtlLabel: 'Pagination_Bar_Layouts_display_pagination_righttoleft_label',
  displayName: 'pagination_definition_label_display_name',
  designCurrentPageLabel: 'pagination_design_section_divider_current',
  designNavigationButtonsLabel: 'pagination_design_section_divider_navigation',
} as const;

export const AriaTranslationKeys = {
  paginationLabel: 'Pagination_AriaLabel_PaginationBar',
  lastPage: 'Pagination_AriaLabel_LastPage',
  previousPage: 'Pagination_AriaLabel_PreviousPage',
  firstPage: 'Pagination_AriaLabel_FirstPage',
  currentPage: 'Pagination_AriaLabel_CurrentPage',
  nextPage: 'Pagination_AriaLabel_NextPage',
  namespace: 'ariaLabels',
};

export const PaginationA11yDataType = 'PaginationA11y';

export const sizingBehaviorPresets: Required<
  Pick<SizingBehaviorPresets, 'Hug' | 'Fixed' | 'RelativeWidth'>
> = {
  RelativeWidth: {
    key: 'RelativeWidth',
    propsToApply: {
      componentLayout: {
        width: 'percentage',
        minWidth: 'maxContent',
        height: 'auto',
      },
    },
    propsToValidate: {
      componentLayout: ['width', 'height', 'minWidth'],
    },
  },
  Fixed: {
    key: 'Fixed',
    propsToApply: {
      componentLayout: {
        height: 'px',
        width: 'px',
        minHeight: 'none',
        maxHeight: 'none',
        minWidth: 'maxContent',
        maxWidth: 'none',
      },
    },
    propsToValidate: {
      componentLayout: ['width', 'height', 'minWidth', 'maxWidth', 'maxHeight'],
    },
  },
  Hug: {
    key: 'Hug',
    propsToApply: {
      componentLayout: {
        width: 'maxContent',
        minWidth: 'none',
        maxWidth: 'none',
        height: 'auto',
        minHeight: 'none',
        maxHeight: 'none',
      },
    },
    propsToValidate: {
      componentLayout: ['width'],
    },
    demonstrationSrc: 'sizingBehavior/text-hug.v2.gif',
  },
};
